import * as React from 'react';
import * as COLOURS from '../../../constants/colours';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& label': {
              color: '#707070',
              opacity: 0.6,
              fontFamily: 'Roboto',
              fontSize: 18,
            },

            '& label.Mui-focused': {
              color: COLOURS.soltaColor,
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            fontSize: 28,
            fontFamily: 'Roboto',
            fontWeight: 300,
            color: '#707070',
            '&:before': {
              borderBottom: `none`,
            },
            '&:hover:not(.Mui-disabled, .Mui-error):before': {
              borderBottom: `none`,
            },
            '&.Mui-focused:after': {
              borderBottom: `none`,
            },
            '&.Mui-focused:before': {
              borderBottom: `none`,
            },
          },
        },
      },
    },
  });

export default function SystemTextField(props) {
  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <TextField {...props} fullWidth />
    </ThemeProvider>
  );
}
